module.exports = __webpack_public_path__ + "img/GENERAL-FRONX-BOOSTERGREEN-3.6e2c3283.jpg";